import { PortfoliosTradesService_portfolioTradesServiceGetEntities } from '@festina/unitlink-general-types/unitlink/hooks/PortfoliosTradesService_portfolioTradesServiceGetEntities'

export const useFetchPortfolioTrades =
  PortfoliosTradesService_portfolioTradesServiceGetEntities.useSuspenseQuery
